import { useTextComponentModel } from './text-component.model'
import { TextComponentView } from './text-component.view'
import type { IComponentProps } from '../common/dashboard.types'

export const TextComponent = (props: IComponentProps) => {
  const { componentRef, ...textComponentModel } = useTextComponentModel(props)
  return (
    <div ref={componentRef}>
      <TextComponentView {...textComponentModel} />
    </div>
  )
}
